module.exports = __webpack_public_path__ + "media/src/img/map-frame-80a2c4b6e48c62a4644d505e75bf718b.png";